import gate from './configForm/gate'
import recognizer from './configForm/recognizer'
import terminal from './configForm/terminal'
import activeTime from './configForm/activeTime'
import warning from './configForm/warning'

const zhCN = {
  pageErrTitle: '页面错误',
  pageErrContent: '信息错误，请返回设备管理列表！',
  backBtn: '返回',
  submitBtn: '提交',

  editDeviceModalTitle: '编辑设备',

  editBtn: '编辑',
  cancelBtn: '取消',

  getingDeviceConfig: '获取设备配置中...',
  submitingDeviceConfig: '提交设备配置中...',

  deviceName: '设备名称',
  deviceNameTxt: '请输入设备名称',
  deviceNameBlank: '设备名称不能为空！',
  deviceNameWarning: '设备名称最多20字！',

  deviceOrg: '所属组织',
  deviceOrgTxt: '请选择所属组织',
  deviceOrgBlank: '所属组织不能为空！',

  deviceStauts: '在线状态',
  deviceVersion: '软件版本',
  deviceAuthCount: '授权人数',
  deviceType: '设备类型',
  deviceSN: '设备SN',

  getDeviceInfoFail: '获取设备信息失败！',
  editDeviceInfoSuccess: '编辑设备信息成功！',
  editDeviceInfoFail: '编辑设备信息失败！',
  submitDeviceConfigSuccess: '提交设备配置成功！',
  submitDeviceConfigFail: '提交设备配置失败！',

  menuTerminal: '终端配置',
  menuGate: '门禁设置',
  menuRecognizer: '识别设置',
  menuWarning: '预警报警设置',
  menuActiveTime: '门禁有效时间',

  visitorMachineConfigTitle: '访客一体机配置',

  maximumAuthorizedTimeTxt: '访客最长授权时间',
  maximumAuthorizedTimeBlank: '访客最长授权时间不能为空！',
  maximumAuthorizedTimeWarning: '请填写正整数！',
  maximumAuthorizedTimUnit: '小时',

  IDType: '访客证件类型',
  IDTypeTxt: '请选访客择证件类型',
  IDTypeBlank: '证件访客类型不能为空！',

  visitReason: '拜访事由',
  visitReasonTxt: '请选访客择拜访事由',
  visitReasonBlank: '拜访事由不能为空！',

  personCantBeVisitor: '系统内人员不允许做为访客',
  personCantBeVisitorBlank: '请选择是否设置系统内人员不允许做为访客！',

  visitorReasonAllowedEdit: '是否允许终端一体机配置拜访事由',
  visitorReasonAllowedEditBlank: '请选择是否允许终端一体机配置拜访事由！',

  option_true: '是',
  options_false: '否',

  gate: gate.zhCN,
  recognizer: recognizer.zhCN,
  terminal: terminal.zhCN,
  activeTime: activeTime.zhCN,
  warning: warning.zhCN
}
const enUS = {
  pageErrTitle: 'Page Error',
  pageErrContent: 'Page error, please return to the device management list!',
  backBtn: 'Back',
  submitBtn: 'Submit',

  editDeviceModalTitle: 'Edit Device',

  editBtn: 'Edit',
  cancelBtn: 'Cancel',

  getingDeviceConfig: 'Getting the device configuration...',
  submitingDeviceConfig: 'Submitting the device configuration...',

  deviceName: 'Device Name',
  deviceNameTxt: 'Enter device name',
  deviceNameBlank: 'Device name can\'t be blank!',
  deviceNameWarning: 'Device name is up to 20 words!',

  deviceOrg: 'Organization',
  deviceOrgTxt: 'Choose organization',
  deviceOrgBlank: 'Organization can\'t be blank!',
  
  deviceStauts: 'Stauts',
  deviceVersion: 'Version',
  deviceAuthCount: 'Authorization Count',
  deviceType: 'Device Type',
  deviceSN: 'SN Number',

  getDeviceInfoFail: 'Get device information failed!',
  editDeviceInfoSuccess: 'Edit device information successfully!',
  editDeviceInfoFail: 'Edit device information failed!',
  submitDeviceConfigSuccess: 'Submit device configuration successfully!',
  submitDeviceConfigFail: 'Submit device configuration failed!',

  menuTerminal: 'Terminal Settings',
  menuGate: 'Gate Settings',
  menuRecognizer: 'Recognizer Settings',
  menuWarning: 'Warning-Alarm Settings',
  menuActiveTime: 'Active Time Settings',

  visitorMachineConfigTitle: 'Visitor all-in-one machine configuration',
  
  maximumAuthorizedTimeTxt: 'Maximum Authorized Time of Visitor',
  maximumAuthorizedTimeBlank: 'Maximum authorized time can\'t be blank!',
  maximumAuthorizedTimeWarning: 'Please fill in positive integers!',
  maximumAuthorizedTimUnit: 'hours',

  IDType: 'ID Type',
  IDTypeTxt: 'Choose ID type',
  IDTypeBlank: 'ID type can\'t be blank!',

  visitReason: 'Visit Reason',
  visitReasonTxt: 'Choose Visit Reason',
  visitReasonBlank: 'Visit reason can\'t be blank!',
  
  personCantBeVisitor: 'Person in the system can\'t be a visitor',
  personCantBeVisitorBlank: 'Please choose whether to set the person in system can\'t be a visitor!',

  visitorReasonAllowedEdit: 'Allow terminal machine set the purpose of visit',
  visitorReasonAllowedEditBlank: 'Please choose whether to allow terminal machine set the purpose of visit!',

  option_true: 'true',
  options_false: 'false',

  gate: gate.enUS,
  recognizer: recognizer.enUS,
  terminal: terminal.enUS,
  activeTime: activeTime.enUS,
  warning: warning.enUS
}

export default { zhCN, enUS }